module.exports = __webpack_public_path__ + "img/JabarJamal-KawtniAsmanakan.a49246dc.jpg";